import * as React from 'react';

export default function SvgComponent(props) {
  return (
    <svg viewBox="0 0 32.31 42.348" {...props}>
      <defs>
        <style>
          {`.st_support{fill:none;stroke:${props.color};stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round;}`}
        </style>
      </defs>
      <g
        id="Group_3370"
        data-name="Group 3370"
        transform="translate(-275.779 -1182.73)"
      >
        <g
          id="Group_3369"
          data-name="Group 3369"
          transform="translate(276.719 1186.524)"
        >
          <g
            id="Group_3366"
            data-name="Group 3366"
            transform="translate(11.623 23.486)"
          >
            <path
              id="Path_4419"
              data-name="Path 4419"
              d="M321.014,1274.71l2.29,10.156-3.591,3-3.591-3,2.29-10.156,1.3,1.281Z"
              transform="translate(-316.122 -1273.598)"
              className="st_support"
            />
            <path
              id="Path_4420"
              data-name="Path 4420"
              d="M325.129,1270.941l-2.279,2.232-2.279-2.232"
              transform="translate(-319.258 -1270.941)"
              className="st_support"
            />
          </g>
          <g
            id="Group_3367"
            data-name="Group 3367"
            transform="translate(0 8.42)"
          >
            <path
              id="Path_4421"
              data-name="Path 4421"
              d="M343.994,1256.984l8.976-1.859-1.187-5.941a5.856,5.856,0,0,0-2.007-3.355,4.789,4.789,0,0,0-1.967-1.032l-5.073-1.473a1.105,1.105,0,0,1-.79-.933l-.234-2.008a8.654,8.654,0,0,0,2.976-4.677"
              transform="translate(-322.54 -1231.033)"
              className="st_support"
              stroke-miterlimit="10"
            />
            <path
              id="Path_4422"
              data-name="Path 4422"
              d="M285,1235.706a8.692,8.692,0,0,0,2.977,4.677l-.232,2.008a1.1,1.1,0,0,1-.789.933l-5.056,1.468a4.793,4.793,0,0,0-1.983,1.038,5.84,5.84,0,0,0-2.008,3.355l-1.187,5.941,8.033,1.664"
              transform="translate(-276.719 -1231.033)"
              className="st_support"
              stroke-miterlimit="10"
            />
            <path
              id="Path_4423"
              data-name="Path 4423"
              d="M303.959,1219.864"
              transform="translate(-295.924 -1219.864)"
              className="st_support"
              stroke-miterlimit="10"
            />
          </g>
          <path
            id="Path_4424"
            data-name="Path 4424"
            d="M318.267,1199.729s.419-8.407-7.138-8.407-7.178,8.42-7.178,8.42"
            transform="translate(-295.916 -1191.322)"
            className="st_support"
            stroke-miterlimit="10"
          />
          <path
            id="Path_4425"
            data-name="Path 4425"
            d="M305.783,1204.119a2.7,2.7,0,0,1,1.5-1.3,4.264,4.264,0,0,1,3.163.378,13.849,13.849,0,0,0,4.286,1.6,7.347,7.347,0,0,0,4.3-.7"
            transform="translate(-297.21 -1199.312)"
            className="st_support"
            stroke-miterlimit="10"
          />
          <g
            id="Group_3368"
            data-name="Group 3368"
            transform="translate(9.875 8.128)"
          >
            <rect
              id="Rectangle_451"
              data-name="Rectangle 451"
              width="3.993"
              height="2.558"
              rx="1.279"
              className="st_support"
              stroke-miterlimit="10"
            />
            <rect
              id="Rectangle_452"
              data-name="Rectangle 452"
              width="3.993"
              height="2.558"
              rx="1.279"
              transform="translate(6.684)"
              className="st_support"
              stroke-miterlimit="10"
            />
            <line
              id="Line_1297"
              data-name="Line 1297"
              x2="2.692"
              transform="translate(3.993 0.941)"
              className="st_support"
              stroke-miterlimit="10"
            />
          </g>
          <line
            id="Line_1298"
            data-name="Line 1298"
            x2="1.843"
            y2="0.823"
            transform="translate(8.032 8.128)"
            className="st_support"
            stroke-miterlimit="10"
          />
          <line
            id="Line_1299"
            data-name="Line 1299"
            y1="0.823"
            x2="1.803"
            transform="translate(20.552 8.128)"
            className="st_support"
            stroke-miterlimit="10"
          />
          <path
            id="Path_4426"
            data-name="Path 4426"
            d="M322.545,1256.772l-4.138,3.705-4.138-3.705"
            transform="translate(-303.192 -1237.465)"
            className="st_support"
          />
          <line
            id="Line_1300"
            data-name="Line 1300"
            y1="0.881"
            x2="4.683"
            transform="translate(21.825 28.385)"
            className="st_support"
          />
        </g>
        <path
          id="Path_4427"
          data-name="Path 4427"
          d="M340.821,1239.617c-1.407,3.643-4.127,4.452-7.966,4.452"
          transform="translate(-39.577 -41.292)"
          className="st_support"
          stroke-miterlimit="10"
        />
        <path
          id="Path_4428"
          data-name="Path 4428"
          d="M297.214,1195.373c.416-6.9,4.795-10.857,9.695-10.857,5.419,0,9.5,4.8,9.5,11.131"
          transform="translate(-14.984 -0.986)"
          className="st_support"
          stroke-miterlimit="10"
        />
        <path
          id="Path_4429"
          data-name="Path 4429"
          d="M297.508,1217.333c.134,2.136,1.4,3.8.243,3.869s-2.2-1.6-2.336-3.737.693-3.928,1.849-4S297.374,1215.2,297.508,1217.333Z"
          transform="translate(-13.171 -20.407)"
          className="st_support"
          stroke-miterlimit="10"
        />
        <path
          id="Path_4430"
          data-name="Path 4430"
          d="M351.783,1217.439c.04-2.14-1.086-3.9.072-3.876s2.064,1.774,2.025,3.915-1.01,3.858-2.168,3.836S351.743,1219.58,351.783,1217.439Z"
          transform="translate(-52.514 -20.479)"
          className="st_support"
          stroke-miterlimit="10"
        />
        <circle
          id="Ellipse_284"
          data-name="Ellipse 284"
          cx="1.121"
          cy="1.121"
          r="1.121"
          transform="translate(291.048 1201.709)"
          className="st_support"
          stroke-miterlimit="10"
        />
        <path
          id="Path_4431"
          data-name="Path 4431"
          d="M329.1,1254.68"
          transform="translate(-36.926 -49.467)"
          className="st_support"
          stroke-miterlimit="10"
        />
      </g>
    </svg>
  );
}
